import { Column } from '../../../shared/types/Column'
import Paper from '@mui/material/Paper'
import TableContainer from '@mui/material/TableContainer'
import Table from '@mui/material/Table'
import { MuiTableHead } from '../../../shared/ui/MuiTableHead/MuiTableHead'
import { StyledTableRow } from '../../../shared/ui/StyledTableRow/StyledTableRow'
import TableCell from '@mui/material/TableCell'
import React, { ReactNode, useEffect, useState } from 'react'
import TableBody from '@mui/material/TableBody'
import { useAppDispatch } from '../../../shared/lib/hooks/useAppDispatch/useAppDispatch'
import {
	fetchNotifications,
	fetchNotificationSubscribers,
	NotificationSubscriber,
	NotificationWithSubscribers,
	selectIsLoading,
	selectNotifications,
	selectNotificationsWithSubscribers
} from '../../../entities/Notifications'
import { useAppSelector } from '../../../shared/lib/hooks/useAppSelector/useAppSelector'
import { NotificationsActions } from './components/NotificationsActions'
import { SubscriberChip } from './components/SubscriberChip'
import Box from '@mui/material/Box'
import { Loader } from '../../../shared/ui/Loader/Loader'
import { NoData } from '../../../shared/ui/NoData/NoData'

const columns: Column[] = [
	{ id: 'notificationName', label: 'Notification', minWidth: 50 },
	{
		id: 'notificationId',
		label: 'ID',
		align: 'left',
		minWidth: 50
	},
	{
		id: 'subscribers',
		label: 'Subscribers',
		align: 'left',
		minWidth: 50
	}
]

export const DisplayNotifications = () => {
	const dispatch = useAppDispatch()
	const notifications = useAppSelector(selectNotifications)
	const notificationsLoading = useAppSelector(selectIsLoading)
	const notificationsWithSubscribers = useAppSelector(selectNotificationsWithSubscribers)
	const [subscribersLoading, setSubscribersLoading] = useState(false)

	useEffect(() => {
		dispatch(fetchNotifications())
	}, [dispatch])

	useEffect(() => {
		if (notifications && notifications.length) {
			setSubscribersLoading(true)
			const promises = notifications.map(
				notis => dispatch(fetchNotificationSubscribers(notis.notificationId))
			)
			Promise.all(promises).then(() => {
				setSubscribersLoading(false)
			}).catch(console.error)
		}
	}, [notifications, dispatch])

	return (
		<Paper
			elevation={3}
			sx={{ width: '100%', border: '1px solid lightgrey' }}
		>
			{notificationsLoading ? (
				<Loader />
			) : notifications && !!notifications.length ? (
				<TableContainer>
					<Table aria-label="sticky table">
						<MuiTableHead
							flag={true}
							columns={columns}
						/>
						<TableBody>
							{notificationsWithSubscribers.map((notis) => {
								return (
									<StyledTableRow
										hover
										role="checkbox"
										tabIndex={-1}
										key={notis.notificationId}
									>
										{columns.map((column) => {
											const value = notis?.[
												column.id as keyof NotificationWithSubscribers
												]
											return (
												<TableCell
													key={column.id + notis.notificationId}
													align={column.align}
												>
													{column.id === 'subscribers' ? (
														!notis.subscribers.length ? (
																<Box sx={{ ml: 'auto' }}>
																	{subscribersLoading ? 'Loading...' : ''}
																</Box>
															)
															: (
																<Box
																	sx={{
																		display: 'flex',
																		flexWrap: 'wrap',
																		gap: 1
																	}}
																>
																	{notis.subscribers.map(
																		(subscriber: NotificationSubscriber) => (
																			<SubscriberChip
																				key={subscriber.userId}
																				content={subscriber.email} />
																		)
																	)}
																</Box>
															)
													) : value as ReactNode}
												</TableCell>
											)
										})}
										<TableCell align="center">
											<NotificationsActions notification={notis} />
										</TableCell>
									</StyledTableRow>
								)
							})}
						</TableBody>
					</Table>
				</TableContainer>
			) : (
				<NoData />
			)}
		</Paper>

	)
}